export default __webpack_public_path__ + "assets/cogir.b9c1e5d0.webp";